(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/api-errors/assets/javascripts/api-calls/netto-loss.js') >= 0) return;  svs.modules.push('/components/tur/api-errors/assets/javascripts/api-calls/netto-loss.js');
'use strict';

const ELZA_TIMEOUT_MS = 4000;
const getNettoLossInfo = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-care');
  if (useOldJupiterApi) {
    const options = {
      method: 'GET',
      path: '/gcs/1/activenetlossrestriction'
    };
    let response;
    let status;
    try {
      var _response;
      var _await$svs$core$jupit = await svs.core.jupiter.callAsync(options);
      response = _await$svs$core$jupit.response;
      status = _await$svs$core$jupit.status;
      return {
        error: status === 'success' ? null : ((_response = response) === null || _response === void 0 ? void 0 : _response.error) || 'error',
        data: status === 'success' ? response : null
      };
    } catch (err) {
      svs.tur.apierrors.logger.info("Error getting ".concat(options.path), err);
      return {
        error: err,
        data: null
      };
    }
  }

  const svsFetch = svs.core.svsFetch.create();
  const elzaPath = '/v1/web/me/rapid-loss/status';
  try {
    const response = await svsFetch(elzaPath, {
      method: 'GET',
      timeout: ELZA_TIMEOUT_MS
    });
    if (!response.ok) {
      if ([401, 403].includes(response.status)) {
        window.location.href = '/logga-ut';
        return {
          error: response.status === 403 ? 'forbidden' : 'unauthorized',
          data: null
        };
      }
      const body = await response.json().catch(() => null);
      const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'error';
      svs.tur.apierrors.logger.info("Error getting ".concat(elzaPath, " (Elza)"), response.status, errorDetail);
      return {
        error: (body === null || body === void 0 ? void 0 : body.error) || errorDetail || 'error',
        data: null
      };
    }
    const body = await response.json();
    return {
      error: null,
      data: body
    };
  } catch (err) {
    svs.tur.apierrors.logger.info("Error getting ".concat(elzaPath, " (Elza)"), err);
    return {
      error: err,
      data: null
    };
  }
};
svs.tur.apierrors.apiCalls = {
  getNettoLossInfo
};

 })(window);